import React from 'react';

import {
  BFS_USER_PROFILE_INDUSTRY,
  USER_PROFILE_COMPANY_ALREADY_CUSTOMER,
  USER_PROFILE_PHONE_NUMBER,
} from 'modules/Inquiry/Form/formFields';
import Section from 'modules/InquiryDetails/DetailedInformation/DetailedInformationSection';
import InformationRows from 'modules/InquiryDetails/DetailedInformation/InformationRows/InformationRows';
import useInquiryDetailsFields from 'modules/InquiryDetails/DetailedInformation/useInquiryDetailsFields';
import { INQUIRY_SECTIONS } from 'modules/InquiryDetails/InquirySections.model';
import { useTranslations } from 'utils/hooks/useTranslations';

// fields excluded from showing for partner
const PARTNER_EXCLUDED_FIELDS = [
  USER_PROFILE_COMPANY_ALREADY_CUSTOMER,
  USER_PROFILE_PHONE_NUMBER,
  BFS_USER_PROFILE_INDUSTRY,
];

const DvagCompanyDetailsSection = () => {
  const t = useTranslations('pages.inquiryDetails.detailed');
  const fields = useInquiryDetailsFields({
    sectionId: INQUIRY_SECTIONS.COMPANY,
    excludedFields: PARTNER_EXCLUDED_FIELDS,
  });
  if (!fields.length) {
    return null;
  }

  return (
    <Section title={t('companyDetails')}>
      <InformationRows fields={fields} />
    </Section>
  );
};

export default DvagCompanyDetailsSection;
